import { render } from "./TokenSelector.vue?vue&type=template&id=227816f1&scoped=true"
import script from "./TokenSelector.vue?vue&type=script&lang=js"
export * from "./TokenSelector.vue?vue&type=script&lang=js"

import "./TokenSelector.vue?vue&type=style&index=0&id=227816f1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227816f1"]])

export default __exports__